import Axios from "axios";
//models
import { IRequestConfig } from "models/Axios";
import { IQuoteBionexoData, IQuoteBionexo } from "models/QuoteBionexo";
///services
import Services from "./index.service";
//utils
import { toastify } from "components/Toastify/utils";
//generics
import qs from "qs";
//components
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";

export default class QuoteBionexoSevices extends Services<
  IQuoteBionexoData,
  IQuoteBionexo
> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  get = (filter?: any) => {
    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/GetAll`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    };

    return this.httpRequest(config);
  };

  getQuotationsDashboard = (filter?: any) => {
    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/GetQuotationsDashboard`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    };

    return this.httpRequest(config);
  };

  getPreOrder = (filter?: any) => {
    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url2,
      url: `/preOrder`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: { ...filter },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    };

    return this.httpRequest(config);
  };

  getPreOrderDetails = (quotationCode: string) => {
    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url2,
      url: `/preOrder/details/${quotationCode}`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return this.httpRequest(config);
  };

  getRescuedCds = (codeQuotation: string) => {
    const config: IRequestConfig<any> = {
      baseUrl: this.mafraq_url2,
      url: `/preOrder/rescued-cds/${codeQuotation}`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return this.httpRequest(config);
  };

  downloadQuotationDetails = (quotationId: string) => {
    return Axios({
      method: 'get',
      baseURL: this.mafraq_url2,
      url: `/quotation/download/${quotationId}`,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Authorization: `Bearer ${this.access_token()}`,
      },
    });
  };

  downloadPreOrderDetails = (quotationCode: string, distributionCenter: string, sequenceNumbers: string[]) => {
    let listSequenceNumbers;
    let url;

    if(IsNullOrEmpty(sequenceNumbers))
      url = `/preOrder/download/${quotationCode}/${distributionCenter}`;
    else {
      listSequenceNumbers = sequenceNumbers.join(",");
      url = `/preOrder/download/${quotationCode}/${distributionCenter}/${listSequenceNumbers}`;
    }

    return Axios({
      method: 'get',
      baseURL: this.mafraq_url2,
      url,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Authorization: `Bearer ${this.access_token()}`,
      },
    });
  };

  preOrderDownloadedRead = async (code: string, distributionCenter: string, sequenceNumbers: string[], isRead?: boolean) => {
    let listSequenceNumbers;
    let url;

    if(!IsNullOrEmpty(sequenceNumbers))
      listSequenceNumbers = sequenceNumbers.join(",");

    return Axios({
      method: 'post',
      baseURL: this.mafraq_url2,
      url: `/preOrder/viewed/${code}/${distributionCenter}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        isRead,
        sequenceNumbers: listSequenceNumbers
      },
    },
    ).then(() => {
      return true;
    }).catch(() => {
      toastify.error('Erro ao atualizar status do pedido.');
      return false;
    });
  };

  expiresToday = (
    subsidiaryId?: string[],
    sellerId?: string[],
    categoriesId?: string[],
    currentPage?: number,
    pageSize?: number
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quotes-expires-today`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $skip: `${skip * top}`,
        sellerId: sellerId,
        productCategories: categoriesId,
        businessUnit: subsidiaryId,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    };

    return this.httpRequest(config);
  };
}
